import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Banner, BannerAction, BannerDescription } from '@wartek-id/banner'
import { Button } from '@wartek-id/button-v1'

import { useQueryAPIGetKSSelectionCandidateBanner } from 'api/bcks/useAPIBCKSInvitation'
import useKSPSTrackEvent from 'app/BCKSPage/hooks/useKSPSTrackEvent'
import styles from '../styles.module.css'

const KSCard = () => {
  const { KSPSTrackEvent } = useKSPSTrackEvent()

  const { data: bannerData, isError: isErrorGetBannerData } =
    useQueryAPIGetKSSelectionCandidateBanner()

  const shouldShowDynamicBanner = bannerData && !isErrorGetBannerData

  if (!shouldShowDynamicBanner) {
    return null
  }

  return (
    <section
      className={clsx(
        styles['base-rgtk-homepage'],
        'bg-white mx-auto flex w-full flex-col'
      )}
    >
      <Banner
        title={bannerData.header}
        closable={false}
        className="!bg-surface-default"
      >
        <BannerDescription>
          <Text
            dangerouslySetInnerHTML={{ __html: bannerData.description }}
            data-testid="ks-selection-card-description"
            variant="body"
          />
        </BannerDescription>

        {bannerData.button?.text && bannerData.button?.redirection && (
          <BannerAction>
            <Button
              as="a"
              href={bannerData.button?.redirection}
              target="_blank"
              className="min-w-28"
              onClick={() => {
                KSPSTrackEvent({
                  event_name: 'click_ksps_banner',
                  additional_info: [
                    {
                      key: 'cta_banner',
                      value: bannerData.button?.text,
                    },
                  ],
                })
              }}
              data-testid="ks-selection-card-link"
              size="sm"
              style={{
                backgroundColor: bannerData.button?.backgroundColor,
                color: bannerData.button?.textColor,
                border: `1px solid ${bannerData.button?.textColor}`,
                width: 'fit-content',
              }}
            >
              {bannerData.button?.text}
            </Button>
          </BannerAction>
        )}
      </Banner>
    </section>
  )
}

export default KSCard
